'use client';

import { useState } from "react";
import cookies from 'js-cookie';

type Props = {
  children: React.ReactNode
}

export default function ThemeToggle({ children, ...props }: Props): JSX.Element {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
    if (!showMenu) window.addEventListener('mouseup',mouseUpTrigger);
  }

  const setTheme = (theme: string): void => {
    document.documentElement.classList.remove('light', 'dark');
    if (theme) {
      document.documentElement.classList.add(theme);
      cookies.set('theme', theme, { expires: 365 });
    } else {
      cookies.remove('theme');
    }
    window.removeEventListener('mouseup', mouseUpTrigger);
  }

  const mouseUpTrigger = (event: MouseEvent): void => {
    event.preventDefault();
    if ((event.target as HTMLElement)?.classList.contains('theme-btn')) return;
    window.removeEventListener('mouseup', mouseUpTrigger);
    setShowMenu(false);
  }

  return (
    <span id="theme-toggle" className="relative" data-tooltip="Theme toggle" {...props}>
      <button className="toggle-btn theme-btn cursor-pointer" onClick={toggleMenu} aria-label="Theme toggle">
        {children}
      </button>
      {showMenu && (
        <div className="selector">
          <button className="theme-btn os" onClick={() => setTheme('')}>System</button>
          <button className="theme-btn light" onClick={() => setTheme('light')}>Light</button>
          <button className="theme-btn dark" onClick={() => setTheme('dark')}>Dark</button>
        </div>
      )}
    </span>
  );
};
